import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
export function withScrollToTop(WrappedComponent) {
    const ScrollToTop = (props) => {
        const componentRef = useRef(null);
        useEffect(() => {
            requestAnimationFrame(() => {
                if (componentRef.current) {
                    componentRef.current.scrollTop = 0;
                }
            });
        }, []);
        return (_jsx("div", Object.assign({ ref: componentRef, style: { overflowY: 'auto', maxHeight: '100%' } }, { children: _jsx(WrappedComponent, Object.assign({}, props)) })));
    };
    return ScrollToTop;
}
//# sourceMappingURL=withScrollToTop.js.map